import React from 'react';
import pt from 'prop-types';
import Button from 'components/button';
import { Section } from 'components/section';
import { REVIEW_STATUS, isAppReviewRejected } from 'shared/app-versions';

export default class AppNewReleaseSection extends React.PureComponent {
  static propTypes = {
    app: pt.object,
    versionRecord: pt.object,
    onPublish: pt.func,
    onSubmitReview: pt.func,
  };

  onClickPublish = (event) => {
    event.preventDefault();

    const { versionRecord, onPublish } = this.props;

    return onPublish(versionRecord);
  };

  onClickSubmitReview = (event) => {
    event.preventDefault();

    const { versionRecord, onSubmitReview } = this.props;

    return onSubmitReview(versionRecord.version);
  };

  getTitle() {
    const { app, versionRecord } = this.props;
    const { review_status: reviewStatus } = versionRecord;

    // A rejection outlives the version it was passed on, so it speaks for the
    // whole section even when a newer release is the one being rendered
    if (isAppReviewRejected(app)) {
      return 'App rejected';
    }

    switch (reviewStatus) {
      case REVIEW_STATUS.UNAPPROVED:
        return 'Release not officially approved';
      case REVIEW_STATUS.NEEDS_CHANGES:
        return 'Release needs changes';
      case REVIEW_STATUS.REJECTED:
        return 'Release rejected';
      default:
        return 'Newer release available';
    }
  }

  getSubtitle() {
    const { app, versionRecord } = this.props;
    const { review_status: reviewStatus, version } = versionRecord;

    if (isAppReviewRejected(app)) {
      return "This app won't be published to the Swell App Store. Reply to the rejection email if you have questions";
    }

    switch (reviewStatus) {
      case REVIEW_STATUS.UNAPPROVED:
        return `Version ${version} can be published without official approval`;
      case REVIEW_STATUS.NEEDS_CHANGES:
        return `Version ${version} needs changes. Submit a new version when it's ready`;
      case REVIEW_STATUS.REJECTED:
        return `Version ${version} was rejected`;
      default:
        return `Version ${version} is ready to be reviewed`;
    }
  }

  getActions() {
    const { app, versionRecord } = this.props;
    const { version, review_status: reviewStatus } = versionRecord;

    // A rejected app is not coming to the App Store, so there is nothing left
    // to submit
    if (isAppReviewRejected(app)) {
      return undefined;
    }

    if (!reviewStatus) {
      const previousReleasedVersion = app.versions?.results?.find(
        (versionRecord) =>
          versionRecord.released &&
          versionRecord.version &&
          versionRecord.version !== version,
      );

      // do not allow publish immediately for now
      const canPublishImmediately =
        false &&
        previousReleasedVersion?.review_status !== REVIEW_STATUS.REJECTED;

      return [
        canPublishImmediately && (
          <Button
            key="new-release-publish-immediately"
            type="secondary"
            size="sm"
            onClick={this.onClickPublish}
          >
            Publish immediately
          </Button>
        ),
        <Button
          key="new-release-review"
          type="default"
          size="sm"
          onClick={this.onClickSubmitReview}
        >
          Submit for review
        </Button>,
      ];
    }

    if (reviewStatus === REVIEW_STATUS.UNAPPROVED) {
      return [
        <Button
          key="new-release-publish"
          type="default"
          size="sm"
          onClick={this.onClickPublish}
        >
          Publish
        </Button>,
      ];
    }
  }

  render() {
    return (
      <Section
        title={this.getTitle()}
        subtitle={this.getSubtitle()}
        actions={this.getActions()}
      />
    );
  }
}
